import React from 'react';
import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { CloudImage } from '@components/CloudImage';
import { Avatar } from '@components/Avatar';
import { TextPairing } from '@components/TextPairing';

export const AllTogetherTableContainer = styled(Flex)`
  width: 100%;
  margin-top: ${themeSpace(11)};
  padding: 0 ${themeSpace(7)};
  ${themeMediaQuery('below_sm')} {
    transform: scale(0.55);
    margin-top: ${themeSpace(0)};
  }
`;

export const AllTogetherTableHeaderWrapper = styled(Flex)`
  width: 100%;
  height: 72px;
  border-top-left-radius: 32px;
  border-top-right-radius: 32px;
  border-bottom: 1px solid ${themeColor('blue3')};
  padding-left: ${themeSpace(7)};
  align-items: center;
`;

export const StyledAllTogetherLastRowWrapper = styled.div`
  height: 50px;
  flex-basis: 50px;
  overflow: hidden;
  flex-shrink: 0;
  align-items: center;
  position: relative;
  border-bottom-left-radius: 32px;
  border-bottom-right-radius: 32px;
  &:nth-child(odd) {
    background-color: transparent;
  }
  &:nth-child(even) {
    background-color: ${themeColor('blue1')};
  }
`;

export const StyledAllTogetherTableRow = styled(Flex)`
  width: 100%;
  height: 80px;
  flex-basis: 80px;
  flex-shrink: 0;
  padding-left: ${themeSpace(7)};
  align-items: center;
  position: relative;
  &:nth-child(odd) {
    background-color: transparent;
  }
  &:nth-child(even) {
    background-color: ${themeColor('blue1')};
  }
`;

export const StyledShadow = styled.div`
  position: absolute;
  height: 103%;
  width: 96%;
  background: ${themeColor('yellow2')};
  box-shadow: 0px 16px 64px ${themeColor('yellow2')};
  border-radius: 16px;
  left: 2%;
  top: 7%;
  z-index: -2;
  filter: blur(32px);
`;

export const RowsContainer = styled(Flex)`
  flex-direction: column;
  height: 442px;
`;

export const TableWrapper = styled.div`
  z-index: 0;
  position: relative;
`;

export const TableDecorLeftImage = styled(CloudImage)`
  position: absolute;
  height: 80%;
  z-index: -1;
  left: 0;
  top: 10%;
  transform: translateX(-24%);
`;
export const TableDecorRightImage = styled(CloudImage)`
  position: absolute;
  height: 38%;
  z-index: -1;
  right: 0;
  top: 40%;
  transform: translateX(31%);
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledTable = styled(Flex)`
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    width: 300%;
  }
  flex-direction: column;
  background-color: ${themeColor('mono7')};
  border-radius: 32px;
`;

export const TableAvatar = styled(Avatar)<{ isHidden?: boolean }>`
  margin-right: 32px;
  visibility: ${({ isHidden }) => (isHidden ? 'hidden' : 'visible')};
`;

export const AnimationOuterContainer = styled.div`
  width: 48px;
  height: 136px;
  position: absolute;
  top: 0;
`;
export const AnimationInnerContainer = styled.div`
  width: 1288px;
  height: 1288px;
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-13.8%, -27.1%);
  ${themeMediaQuery('sm')} {
    width: 650px;
    height: 650px;
  }
  ${themeMediaQuery('md')} {
    width: 1070px;
    height: 1070px;
  }
  ${themeMediaQuery('lg')} {
    width: 1288px;
    height: 1288px;
  }
`;

export const Spacer1 = styled.div`
  height: 850px;
  ${themeMediaQuery('below_sm')} {
    height: 780px;
  }
`;

export const Spacer2 = styled.div`
  height: 900px;
  ${themeMediaQuery('below_sm')} {
    height: 380px;
  }
`;

export const Spacer3 = styled.div`
  height: 200px;
  ${themeMediaQuery('below_sm')} {
    height: 100px;
  }
`;

export const HouseHoldTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 310px;
    ${themeMediaQuery('xl')} {
      max-width: 370px;
    }
  }
`;
